/**
 * GoogleSignInButton.js
 *
 * A minimal, clean button for Google sign-in.
 */

import React, { useState } from "react";

const GoogleSignInButton = ({ signInWithGoogle, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleGoogle = async () => {
        setError("");
        setLoading(true);
        try {
            await signInWithGoogle();
            onSuccess();
        } catch (err) {
            setError("Google sign-in failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col space-y-2">
            <button
                onClick={handleGoogle}
                disabled={loading}
                className="
                    border border-zinc-300 rounded-lg py-2 font-medium
                    hover:bg-zinc-200 transition-colors disabled:opacity-50
                "
            >
                {loading ? "Connecting..." : "Continue with Google"}
            </button>
            {error && <p className="text-red-500 text-sm text-center">{error}</p>}
        </div>
    );
};

export default GoogleSignInButton;